import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgStarMagicGlowFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.882 14.345a1.46 1.46 0 0 0-.263-2.044l-2.524-1.909a.44.44 0 0 1-.174-.375l.173-3.178a1.43 1.43 0 0 0-.265-.92 1.444 1.444 0 0 0-2.005-.339l-2.638 1.84a.45.45 0 0 1-.418.052l-2.976-1.11-.022-.008a1.55 1.55 0 0 0-.876-.024 1.476 1.476 0 0 0-1.007 1.811l.896 3.048a.46.46 0 0 1-.086.417l-2.013 2.501c-.208.26-.32.57-.325.895a1.444 1.444 0 0 0 1.42 1.458l3.196.05c.142 0 .275.072.355.193l1.728 2.646c.178.279.446.485.731.571a1.42 1.42 0 0 0 1.108-.055c.353-.17.62-.469.747-.837l1.074-3.013a.46.46 0 0 1 .315-.294l3.09-.862c.316-.094.58-.274.76-.514M11.588 5.11a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-1.5 0v1.36c0 .414.336.75.75.75M19.686 9.7a.8.8 0 0 0 .229-.036l.902-.29a.75.75 0 0 0-.46-1.428l-.9.29a.75.75 0 0 0 .229 1.464M4.635 10.56h-1.22a.75.75 0 0 0 0 1.5h1.22a.75.75 0 0 0 0-1.5M9.556 18.568a.75.75 0 0 0-.947.478l-.316.96a.749.749 0 1 0 1.425.469l.316-.96a.75.75 0 0 0-.478-.947M18.846 18.1a.75.75 0 0 0-1.061-.039.75.75 0 0 0-.037 1.06l2.228 2.39a.747.747 0 0 0 1.06.038.75.75 0 0 0 .038-1.06z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgStarMagicGlowFilled);
export default ForwardRef;
